import { useQuery } from "@tanstack/react-query";
import {
  type OrbitLOnboardingActionRequiredCountResult,
  getMerchantsOrbitLOnboardingActionRequiredCount,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const ORBIT_L_ONBOARDING_ACTION_REQUIRED_COUNT_QUERY_KEY =
  "ORBIT_L_ONBOARDING_ACTION_REQUIRED_COUNT";

export const orbitLOnboardingActionRequiredCountKeys = {
  all: [ORBIT_L_ONBOARDING_ACTION_REQUIRED_COUNT_QUERY_KEY],
};

type QueryOptions = { enabled?: boolean };

export const useOrbitLOnboardingActionRequiredCountQuery = ({
  enabled = true,
}: QueryOptions = {}) =>
  useQuery<OrbitLOnboardingActionRequiredCountResult>({
    queryKey: orbitLOnboardingActionRequiredCountKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsOrbitLOnboardingActionRequiredCount(),
    ),
    enabled,
    staleTime: 2 * MS_TIME.minute,
  });
